import { ImageTextAlignment } from '@/types/enums'
import { ImageWithText } from './'
import createUmbracoMediaItemProps from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
export default function imageWithTextFactory(data: any, key: string | number) {
  const content = data.content.properties

  const mediaItem = content?.mediaItem?.items[0].content
  const mediaItemProps = createUmbracoMediaItemProps({
    mediaItemContent: mediaItem,
    umbracoBaseUrl: GetUmbracoBaseUrl(),
  })

  return (
    <ImageWithText
      key={`image-text-block-${key}`}
      title={content?.title?.markup}
      intro={content?.intro}
      markup={content?.body?.markup}
      mediaData={mediaItemProps}
      alignment={content?.alignment?.toLowerCase() || ImageTextAlignment.Left}
    />
  )
}
